var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{attrs:{"height":"2rem","max":_vm.max}},[_c('b-progress-bar',{attrs:{"value":_vm.value,"variant":(_vm.value / _vm.max > 0.75) ? 'danger' : 'primary'}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }